<template>
  <div class="layout-main-wrapper">
    <transition name="fade">
      <div v-if="selectedAccount" class="desktop-location-logo-wrapper">
        <div v-if="!selectedAccount.logo" class="location-name">
          {{ selectedAccount.name }}
        </div>
        <div v-else class="location-logo-img-wrapper">
          <img :src="selectedAccount.logo" alt="location-logo" />
        </div>
      </div>
    </transition>

    <div class="general-repair-layout">
      <custom-wizard-heading title="Add contact info" :active-index="3" :is-mso="isMSO" />

      <custom-wizard-progress :total-steps="4" :current-step="3" />

      <form-wizard color="#377DFF" :subtitle="null" :title="null" shape="circle" :hide-buttons="true">
        <tab-content>
          <div class="add-info-substep">
            <transition name="fade-faster">
              <customer-phone-otp
                v-if="selectedAccount"
                :account-slug="selectedAccount?.slug"
                :account-name="selectedAccount?.name"
                :account-otp-setting="selectedAccount?.otp_service"
                :account-required-opt-in="selectedAccount?.required_opt_in"
                action-button-disabled
              />
            </transition>
          </div>
        </tab-content>
      </form-wizard>

      <shopgenie-footer />
    </div>

    <desktop-footer :account-slug="selectedAccount?.slug" />
  </div>
</template>

<script>
import CustomWizardHeading from '@/components/CustomWizardHeading';
import CustomWizardProgress from '@/components/CustomWizardProgress';
import { FormWizard, TabContent } from 'vue-form-wizard';
import ShopgenieFooter from '@/components/ShopgenieFooter';
import DesktopFooter from '@/components/DesktopFooter';
import CustomerPhoneOtp from '@/components/customer-info-step/CustomerPhoneOtp';

import CompanyService from '@/services/CompanyService';

export default {
  name: 'OtpPreview',
  components: {
    CustomWizardHeading,
    CustomWizardProgress,
    FormWizard,
    TabContent,
    CustomerPhoneOtp,
    ShopgenieFooter,
    DesktopFooter,
  },
  data() {
    return {
      isMSO: true,
      selectedAccount: null,
    };
  },
  computed: {
    companySlug() {
      return this.$route.query?.shop || null;
    },
    preselectAccountSlug() {
      return this.$route.query?.preselect_account || null;
    },
  },
  methods: {
    async fetchAccountData() {
      const {
        data: { data: companyLocations },
      } = await CompanyService.get.companyAccounts(this.companySlug);

      this.selectedAccount = this.preselectAccountSlug
        ? companyLocations.find(({ slug }) => slug === this.preselectAccountSlug)
        : companyLocations.at(0);

      this.isMSO = companyLocations.length > 1;
    },
  },
  mounted() {
    this.fetchAccountData();
  },
};
</script>

<style>
</style>